module.exports = __webpack_public_path__ + "static/media/vrsc.1eafa231.svg";